(function($, d, g) {
	
	'use strict';

    var $contractPopup;
    var contractKey = ("pmi_" + btoa("contract_agreement")).replace(/=/g, "");
    var contractVal = encodeURIComponent(btoa("accepted"));

    function hideContractPopup(e) {
        setContract(contractKey, contractVal, 24);
        e.delegateTarget.style.display = "none";
    }

    function setContract(cname, cvalue, exhours) {
        var dt = new Date();
        dt.setTime(dt.getTime() + (exhours * 60 * 60 * 1000));
        var expires = "expires=" + dt.toUTCString();
        d.cookie = cname + "=" + cvalue + ";" + expires + ";";
    }

    function getContract(cname) {
        var name = cname + "=";
        var ca = d.cookie.split(";");
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == " ") {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    var init = function () {
        $contractPopup = $(".contract-popup");
        if ($contractPopup.length && getContract(contractKey) !== contractVal) {
            $contractPopup.show();
            $contractPopup.on("click", ".closeContractPopup", hideContractPopup);
        }
    }

	$(init);
	
})(jQuery, document, window);